import PropTypes from "prop-types";
import TiltifyIcon from "@/svg/tiltify-icon.jsx";
import { openTiltifyOAuthPopup } from "@/util/tiltifyHelper.js";

TiltifyOAuthButton.propTypes = {
  setTiltifyUser: PropTypes.func,
};

/**
 * Handles the Tiltify OAuth button and login state. Login state is based on the presence of a username field.
 * @returns
 */
export function TiltifyOAuthButton({ setTiltifyUser = (_user) => {} }) {
  return (
    <div className="min-h-10">
      <div className="my-4">
        <button
          type="button"
          className="btn btn-secondary tiltify w-full"
          data-track="tiltify-oauth-setup"
          onClick={() => openTiltifyOAuthPopup(setTiltifyUser)}
        >
          Connect to Tiltify
          <TiltifyIcon classname="w-7 h-7 ml-2 mr-0 inline" />
        </button>
      </div>
    </div>
  );
}
